/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Start_DescriptionInputs */

const en_welcome_start_description = /** @type {(inputs: Welcome_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The 3D demo runs on local mock data and is independent from the backend session above. You can launch it whenever the server is ready.`)
};

const fr_welcome_start_description = /** @type {(inputs: Welcome_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La démo 3D tourne sur des données mock locales et est indépendante de la session backend ci-dessus. Vous pouvez la lancer dès que le serveur est prêt.`)
};

const ms_sg2_welcome_start_description = /** @type {(inputs: Welcome_Start_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo 3D dijalankan pada data ejekan tempatan dan bebas daripada sesi backend di atas. Anda boleh melancarkannya bila-bila pelayan sedia.`)
};

/**
* | output |
* | --- |
* | "The 3D demo runs on local mock data and is independent from the backend session above. You can launch it whenever the server is ready." |
*
* @param {Welcome_Start_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_start_description = /** @type {((inputs?: Welcome_Start_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Start_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_start_description(inputs)
	if (locale === "fr") return fr_welcome_start_description(inputs)
	return ms_sg2_welcome_start_description(inputs)
});